import api from '@/core/api/client';

export interface MetaSettingsData {
  id: number;
  metaAppId: string | null;
  metaAppSecret: string | null;
  metaConfigId: string | null;
  metaRedirectUri: string | null;
  metaWebhookVerifyToken: string | null;
  metaGraphVersion: string | null;
  metaAccessToken: string | null;
  /** Deployment URLs are read-only and resolved by the backend. */
  metaWebhookUrl?: string | null;
  metaInboxRedirectUri?: string | null;
  /** @deprecated Mantido por compatibilidade — não é mais editável pela UI nem usado pelo backend. */
  metaPhoneNumberId?: string | null;
  updatedAt: string;
}

export const metaSettingsService = {
  async get(): Promise<MetaSettingsData> {
    const res = await api.get('/configuracoes/meta');
    return res.data;
  },

  async update(data: Partial<MetaSettingsData>): Promise<MetaSettingsData> {
    const res = await api.patch('/configuracoes/meta', data);
    return res.data;
  },
};
